import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './components/LandingPage';
import { ManifestoPage } from './components/manifesto/ManifestoPage';
import { TeamPage } from './components/team/TeamPage';
import { FamilyMembersPage } from './components/family/FamilyMembersPage';
import { ReferencesPage } from './components/references/ReferencesPage';
import { GetInTouchPage } from './components/contact/GetInTouchPage';
import { NotFoundPage } from './components/NotFoundPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/manifesto" element={<ManifestoPage />} />
          <Route path="/family" element={<FamilyMembersPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/references" element={<ReferencesPage />} />
          <Route path="/contact" element={<GetInTouchPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;